import { HYDRATE } from "next-redux-wrapper";
import { ActionsPromotionBrowse } from "./actions";

const initialState = { data: {}, status: "fetch_init", message: "" };

function storePromotionsBrowse(state = initialState, action) {

	switch (action.type) {

	case HYDRATE: {

		return { ...state, ...action.payload.storePromotionsBrowse };

	}
	case ActionsPromotionBrowse.LOAD_GET_PROMOTION_BROWSE:
		return { ...state, data: action.data, status: "fetch_loading" };
	case ActionsPromotionBrowse.RES_GET_PROMOTION_BROWSE:
		return { ...state, data: action.data, status: "fetch_result" };
	case ActionsPromotionBrowse.ERR_GET_PROMOTION_BROWSE:
		return {
			...state, data: {}, status: "fetch_error", message: "Error...",
		};
	default: {

		return {
			...state,
		};

	}

	}

}

export default storePromotionsBrowse;
